import * as React from 'react';
import {observer} from 'mobx-react';
import {UIState} from 'data/UIState';
import './Spinner.pcss';

@observer
export class Spinner extends React.Component {
  render() {
    if(!UIState.showSpinner) {
      return null;
    } else {
      return (
        <div className="spinner">
          <div className="panel">
            <p><span className="wheel material-icons">autorenew</span></p>
            <h1 className={'level1'}>{UIState.spinnerTitle}</h1>
            {UIState.spinnerDetails && <p>{UIState.spinnerDetails}</p>}
          </div>
        </div>
      );
    }
  }
}
